export class HeaderMenu  {
    routerLink: string;
    label: string;
    icon?: string;
    helper?: string;
    children?: any[];

    constructor(routerLink: string, label: string, icon?: string, children?: any[], helper?: string) {
        this.routerLink = routerLink;
        this.label      = label;
        this.icon       = icon;
        this.children   = children ? children : [];
        this.helper     = helper;
    }
}
